import { addJs } from '../utils/documentMethods';

const ANTI_FLICKER_CONCERN_CODE = 'afs';
const ANTI_FLICKER_KEY = 'antiflicker';

export default class AntiFlickerProcessor {
  process(baseConfig: any) {
    const antiFlickerConfig = baseConfig[ANTI_FLICKER_KEY];
    const antiFlickerScriptSrcMin = antiFlickerConfig.script.src.minified;
    addJs(antiFlickerScriptSrcMin, 'head', { id: 'antiflicker' });
  }

  getConcernCode() {
    return ANTI_FLICKER_CONCERN_CODE;
  }
}
